import styled from 'styled-components';

export const Section = styled.section`
  padding: 5rem 1.5rem;
  background: ${({ theme }) => theme.colors.white};
`;

export const Grid = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 3rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    grid-template-columns: 1fr;
  }
`;

export const InfoCol = styled.div`
  .eyebrow {
    display: inline-block;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.28em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.goldDark};
    padding-bottom: 0.5rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gold};
    margin-bottom: 1.25rem;
  }

  h2 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: clamp(1.8rem, 3vw, 2.4rem);
    color: ${({ theme }) => theme.colors.nearBlack};
    margin-bottom: 1rem;
  }

  > p {
    color: ${({ theme }) => theme.colors.textMuted};
    line-height: 1.8;
    margin-bottom: 2rem;
  }
`;

export const InfoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.25rem 1.25rem 1.25rem 1.25rem;
  background: ${({ theme }) => theme.colors.offWhite};
  border-left: 3px solid ${({ theme }) => theme.colors.gold};

  .icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.nearBlack};
    color: ${({ theme }) => theme.colors.gold};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .label {
    font-size: 0.72rem;
    letter-spacing: 0.24em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.goldDark};
    font-weight: 600;
    margin-bottom: 0.25rem;
  }

  .value {
    color: ${({ theme }) => theme.colors.nearBlack};
    font-weight: 500;
    font-size: 0.98rem;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
`;

export const FormCard = styled.form`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.border};
  padding: 2.5rem;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 3px;
    background: ${({ theme }) => theme.colors.gold};
  }

  h3 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: 1.5rem;
    color: ${({ theme }) => theme.colors.nearBlack};
    margin-bottom: 0.5rem;
  }

  .sub {
    color: ${({ theme }) => theme.colors.textMuted};
    margin-bottom: 1.75rem;
    font-size: 0.95rem;
  }
`;

export const Field = styled.div`
  margin-bottom: 1.25rem;

  label {
    display: block;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.nearBlack};
    margin-bottom: 0.5rem;
  }

  input, textarea {
    width: 100%;
    padding: 0.85rem 1rem;
    border: 1px solid ${({ theme }) => theme.colors.border};
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.nearBlack};
    font-family: inherit;
    transition: ${({ theme }) => theme.transitions.base};

    &:focus {
      border-color: ${({ theme }) => theme.colors.gold};
      outline: none;
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.goldSoft};
    }
  }

  textarea {
    resize: vertical;
    min-height: 140px;
  }
`;

export const SubmitBtn = styled.button`
  padding: 0.95rem 2rem;
  background: ${({ theme }) => theme.colors.nearBlack};
  color: #fff;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  font-size: 0.82rem;
  border: 1px solid ${({ theme }) => theme.colors.nearBlack};
  transition: ${({ theme }) => theme.transitions.base};

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.gold};
    color: ${({ theme }) => theme.colors.nearBlack};
    border-color: ${({ theme }) => theme.colors.gold};
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

export const Note = styled.div`
  margin-top: 1rem;
  padding: 0.9rem 1rem;
  font-size: 0.88rem;
  background: ${({ theme, $error }) => ($error ? '#FDECEA' : theme.colors.goldSoft)};
  color: ${({ theme, $error }) => ($error ? theme.colors.danger : theme.colors.goldDark)};
  border-left: 3px solid ${({ theme, $error }) => ($error ? theme.colors.danger : theme.colors.gold)};
`;
